<template>
  <div class="project-edit-manage">
    <side-view>
      <template #left>
        <div class="app-panel blank-v blank-h">
          <div class="app-title mb">{{title}}</div>
          <div class="tabs">
            <p :class="{active: tabsIndex === index}" v-for="(value, index) in tabs" :key="index" @click="switchTab(index)">{{value.name}}</p>
          </div>
        </div>
      </template>
      <template #right>
        <div class="app-panel blank-v blank-h">
          <project-staff-manage v-if="tabsIndex === 0"></project-staff-manage>
          <project-device-manage v-else-if="tabsIndex === 1"></project-device-manage>
          <project-account-manage v-else-if="tabsIndex === 2"></project-account-manage>
          <project-param-settings v-else></project-param-settings>
        </div>
      </template>
    </side-view>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import SideView from '@/components/SideView.vue';
  import ProjectStaffManage from '@/views/ProjectStaffManage.vue';
  import ProjectDeviceManage from '@/views/ProjectDeviceManage.vue';
  import ProjectAccountManage from '@/views/ProjectAccountManage.vue';
  import ProjectParamSettings from '@/views/ProjectParamSettings.vue';

  export default {
    name: 'ProjectEditManage',
    data() {
      return {
        id: this.$route.params.id,
        title: '',
        tabs: [
          {
            name: '员工管理',
            icon: 'el-icon-s-custom'
          },
          {
            name: '设备管理',
            icon: 'el-icon-s-platform'
          },
          {
            name: '账号管理',
            icon: 'el-icon-postcard'
          },
          {
            name: '参数配置',
            icon: 'el-icon-s-tools'
          }
        ],
        tabsIndex: 0
      }
    },

    mounted () {
      ProjectService.info(this.id).then(res => {
        this.title = res.data.attr_data.project_attr_name;
      }).catch(() => {});
    },
    methods: {
      switchTab(index) {
        this.tabsIndex = index;
      }
    },
    components: {
      SideView,
      ProjectStaffManage,
      ProjectDeviceManage,
      ProjectAccountManage,
      ProjectParamSettings
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .project-edit-manage {
    .tabs {
      p {
        padding: 10px 20px;
        font-size: 14px;
        color: @color-text-3;
        cursor: pointer;
        transition: all @time;
        border-radius: 4px;
        & + p {
          margin-top: 10px;
        }
        &.active {
          background-color: @color-primary;
          color: @color-white;
        }
        &:hover {
          padding-left: 25px;
        }
        i {
          margin-right: 5px;
        }
      }
    }
  }
</style>